module.exports = __webpack_public_path__ + "img/ifs-logo-208x34.34000728.png";